// Akimi Studio — interactions
(function () {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  root.classList.add("js");

  /* ---------- hero entrance ---------- */
  document.querySelectorAll(".ear-lines .draw").forEach((path) => {
    path.style.setProperty("--len", Math.ceil(path.getTotalLength()));
  });
  document.querySelectorAll(".ear-points .pt").forEach((pt, i) => pt.style.setProperty("--i", i));

  const start = () => requestAnimationFrame(() => root.classList.add("is-loaded"));
  if (document.fonts && document.fonts.ready) {
    // wait for fonts so the headline doesn't reflow mid-animation, but never longer than 1.2s
    Promise.race([document.fonts.ready, new Promise((r) => setTimeout(r, 1200))]).then(start);
  } else {
    start();
  }

  /* ---------- header ---------- */
  const header = document.querySelector(".site-header");
  const onScroll = () => header.classList.toggle("is-scrolled", window.scrollY > 8);
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  const toggle = document.querySelector(".menu-toggle");
  const navList = document.getElementById("nav-list");
  const setMenu = (open) => {
    toggle.setAttribute("aria-expanded", String(open));
    toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    navList.classList.toggle("is-open", open);
  };
  toggle.addEventListener("click", () => setMenu(toggle.getAttribute("aria-expanded") !== "true"));
  navList.addEventListener("click", (e) => { if (e.target.closest("a")) setMenu(false); });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") setMenu(false); });

  /* ---------- Aftercare dropdown: click or tap the arrow to open (hover also works) ---------- */
  document.querySelectorAll(".has-dropdown").forEach((item) => {
    const btn = item.querySelector(".dropdown-toggle");
    if (!btn) return;
    const setOpen = (open) => { item.classList.toggle("is-open", open); btn.setAttribute("aria-expanded", String(open)); };
    btn.addEventListener("click", (e) => { e.stopPropagation(); setOpen(!item.classList.contains("is-open")); });
    document.addEventListener("click", (e) => { if (!item.contains(e.target)) setOpen(false); });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") setOpen(false); });
    item.querySelectorAll(".dropdown a").forEach((a) => a.addEventListener("click", () => setOpen(false)));
  });

  /* ---------- ear map ---------- */
  const points = document.querySelectorAll(".ear-points .pt");
  const capName = document.querySelector(".ear-caption-name");
  const capNote = document.querySelector(".ear-caption-note");

  const selectPoint = (pt) => {
    points.forEach((p) => p.classList.toggle("is-active", p === pt));
    capName.textContent = pt.dataset.name;
    capNote.textContent = pt.dataset.note;
  };
  points.forEach((pt) => {
    pt.setAttribute("aria-label", pt.dataset.name);
    pt.addEventListener("click", () => selectPoint(pt));
    pt.addEventListener("mouseenter", () => selectPoint(pt));
    pt.addEventListener("focus", () => selectPoint(pt));
    pt.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); selectPoint(pt); }
    });
  });

  /* ---------- timeline line ---------- */
  const timeline = document.querySelector(".timeline");
  if (timeline && "IntersectionObserver" in window && !reduceMotion) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add("is-visible"); io.disconnect(); }
      });
    }, { threshold: 0.25 });
    io.observe(timeline);
  } else if (timeline) {
    timeline.classList.add("is-visible");
  }

  /* ---------- aftercare page: healing chart + "on this page" highlight ---------- */
  const healChart = document.querySelector(".heal-chart");
  if (healChart) {
    if ("IntersectionObserver" in window && !reduceMotion) {
      const io = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) { healChart.classList.add("is-visible"); io.disconnect(); }
      }, { threshold: 0.3 });
      io.observe(healChart);
    } else {
      healChart.classList.add("is-visible");
    }
  }
  const tocLinks = document.querySelectorAll(".care-toc a");
  if (tocLinks.length && "IntersectionObserver" in window) {
    const byId = {};
    tocLinks.forEach((a) => (byId[a.getAttribute("href").slice(1)] = a));
    tocLinks[0].classList.add("is-current");
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        tocLinks.forEach((a) => a.classList.remove("is-current"));
        const link = byId[entry.target.id];
        if (link) link.classList.add("is-current");
      });
    }, { rootMargin: "-30% 0px -60% 0px" });
    document.querySelectorAll(".care-section, #help").forEach((s) => io.observe(s));
  }

  /* ---------- aftercare page: downsizing checker (coupon ticket) ---------- */
  const dsTool = document.getElementById("downsize-checker");
  if (dsTool) {
    const sel = document.getElementById("ds-piercing");
    const dateIn = document.getElementById("ds-date");
    const out = document.getElementById("ds-result");
    const badgeBig = document.getElementById("ds-badge-big");
    const badgeSub = document.getElementById("ds-badge-sub");
    const bookBtn = document.getElementById("ds-book");
    const DAY = 86400000;
    const fmt = (d) => d.toLocaleDateString("en-PH", { month: "short", day: "numeric", year: "numeric" });
    const fmtMonth = (d) => d.toLocaleDateString("en-PH", { month: "long", year: "numeric" });
    const today = new Date(); today.setHours(0, 0, 0, 0);
    // local date, not UTC, so "today" is right in the Philippines
    dateIn.max = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
    const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
    if (dsTool.dataset.booking) bookBtn.href = dsTool.dataset.booking;

    const stub = (big, sub, state, btn) => {
      badgeBig.textContent = big;
      badgeSub.textContent = sub;
      dsTool.dataset.state = state || "";
      bookBtn.textContent = btn || "Book your downsize";
    };
    const healLine = (heal, healMonths, pierced) => {
      if (!heal) return "";
      const around = pierced && healMonths ? new Date(pierced.getFullYear(), pierced.getMonth() + healMonths, 1) : null;
      return `<p class="ds-heal"><svg class="ds-heal-star" aria-hidden="true"><use href="#sparkle"/></svg>Full healing takes about ${esc(heal)}${around ? `, so around ${fmtMonth(around)}` : ""}.</p>`;
    };

    const render = () => {
      const opt = sel.selectedOptions[0];
      if (!opt || (!opt.value && opt.disabled)) return;
      const name = esc(opt.textContent.trim().toLowerCase());
      const from = +opt.dataset.from, to = +opt.dataset.to;
      const heal = opt.dataset.heal, healMonths = +opt.dataset.healMonths;
      let pierced = dateIn.value ? new Date(dateIn.value + "T00:00:00") : null;

      if (pierced && pierced > today) {
        out.innerHTML = `<p class="ds-sub">That date is in the future. Pick the day you got pierced.</p>`;
        stub("?", "check the date", "");
        return;
      }

      // some piercings (daith, septum) have no set window: the piercer decides
      if (opt.dataset.ask === "true") {
        out.innerHTML = `<p class="ds-big">Ask your piercer</p><p class="ds-sub">Downsizing for a ${name} depends on your jewelry and how it’s healing, so we’ll tell you when it’s time at your check-up.</p>${healLine(heal, healMonths, pierced)}`;
        stub("ask", "your piercer", "ask", "Book a check-up");
        return;
      }
      if (!from) {
        out.innerHTML = `<p class="ds-big">Usually not needed</p><p class="ds-sub">A ${name} doesn’t usually need downsizing. Come in for a check-up if anything feels off.</p>${healLine(heal, healMonths, pierced)}`;
        stub("✦", "no downsize", "", "Book a check-up");
        return;
      }
      if (!pierced) {
        out.innerHTML = `<p class="ds-big">${from} to ${to} weeks</p><p class="ds-sub">after your piercing is the usual downsizing window for a ${name}. Add the date you got it to see your dates.</p>`;
        stub(`${from}–${to}`, "weeks", "");
        return;
      }

      const start = new Date(pierced.getTime() + from * 7 * DAY);
      const end = new Date(pierced.getTime() + to * 7 * DAY);
      const days = Math.round((start - today) / DAY);
      let note = "";
      if (today < start) stub(String(days), days === 1 ? "day to go" : "days to go", "soon");
      else if (today <= end) stub("now", "it’s time", "now");
      else { stub("late", "book soon", "late"); note = " Book soon so the longer post doesn’t start to tilt."; }
      out.innerHTML = `<p class="ds-label-dark">Your downsizing window</p><p class="ds-big">${fmt(start)} to ${fmt(end)}</p><p class="ds-sub">${from} to ${to} weeks after your piercing.${note}</p>${healLine(heal, healMonths, pierced)}`;
    };
    sel.addEventListener("change", render);
    dateIn.addEventListener("change", render);
    dateIn.addEventListener("input", render);
  }
  /* ---------- reviews: slow endless slide ---------- */
  const reviewRow = document.querySelector(".review-row");
  const reviewTrack = document.querySelector(".review-track");
  if (reviewTrack) {
    const cards = [...reviewTrack.children];
    // a second copy makes the loop seamless; hidden from screen readers
    cards.forEach((card) => {
      const copy = card.cloneNode(true);
      copy.setAttribute("aria-hidden", "true");
      reviewTrack.appendChild(copy);
    });
    // about 9 seconds per card keeps the pace slow and readable
    reviewTrack.style.setProperty("--slide-duration", cards.length * 9 + "s");

    // pause while a finger is on it (touch screens have no hover)
    reviewRow.addEventListener("touchstart", () => reviewRow.classList.add("is-paused"), { passive: true });
    reviewRow.addEventListener("touchend", () => reviewRow.classList.remove("is-paused"));
  }

  /* ---------- FAQ: one open at a time ---------- */
  const faqs = document.querySelectorAll(".faq-list details");
  faqs.forEach((d) => d.addEventListener("toggle", () => {
    if (d.open) faqs.forEach((o) => { if (o !== d) o.open = false; });
  }));

  /* Sparkle Club signups are handled by Shopify's customer form (see sections/akimi-sparkle-club.liquid). */

  /* ---------- product page: photo thumbnails and variant price ---------- */
  const mainImg = document.querySelector(".product-main-media img");
  document.querySelectorAll("[data-gallery-thumb]").forEach((thumb) => {
    thumb.addEventListener("click", () => {
      if (!mainImg) return;
      mainImg.src = thumb.dataset.galleryThumb;
      mainImg.removeAttribute("srcset");
      document.querySelectorAll("[data-gallery-thumb]").forEach((t) => t.removeAttribute("aria-current"));
      thumb.setAttribute("aria-current", "true");
    });
  });
  const variantSelect = document.querySelector("[data-variant-select]");
  const priceEl = document.querySelector("[data-price]");
  if (variantSelect && priceEl) {
    variantSelect.addEventListener("change", () => {
      const opt = variantSelect.selectedOptions[0];
      if (opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
    });
  }

  /* ---------- cart: change quantity, then update the cart automatically ---------- */
  document.querySelectorAll("[data-autosubmit]").forEach((input) => {
    input.addEventListener("change", () => input.form && input.form.submit());
  });

  /* ---------- footer year ---------- */
  const year = document.getElementById("year");
  if (year) year.textContent = new Date().getFullYear();
})();
